import { toast, ToastContainer } from 'react-toastify';

import { AccountPage, AuthPage } from '../../pages';

import '@ws/shared/src/styles/index.css';
import styles from './App.module.css';
import 'react-toastify/dist/ReactToastify.css';

export function App() {
  // SPA-style routing via URL param. `?view=account` opens AccountPage; otherwise AuthPage.
  // Note: `view` is a separate param from `mode` (STANDALONE/EMBEDDED) — popup-embed flows
  // (`?mode=embedded&coords=...`) keep working because `view` is absent there.
  const view = new URLSearchParams(window.location.search).get('view');
  const Body = view === 'account' ? <AccountPage /> : <AuthPage />;

  return (
    <div className={styles['app']}>
      {Body}

      <ToastContainer
        autoClose={3000}
        draggable={true}
        position={toast.POSITION.BOTTOM_RIGHT}
        className={styles['custom-toaster']}
      />
    </div>
  );
}
